import { render } from "./UploadExcel.vue?vue&type=template&id=67ba66d6"
import script from "./UploadExcel.vue?vue&type=script&lang=ts"
export * from "./UploadExcel.vue?vue&type=script&lang=ts"
script.render = render

export default script